<script src="<%= BASE_URL %>plugins/jquery/jquery-3.6.0.min.js"></script>
<template>
    <div>    
        <DxLoadPanel
            :visible="loadingVisible"
            :show-indicator="showIndicator"
            :show-pane="showPane"
            :shading="shading"
            :close-on-outside-click="closeOnOutsideClick"
            :on-shown="onShown"
            :on-hidden="onHidden"
            shading-color="rgba(0,0,0,0.4)"
        />
        <div class="hold-transition login-page">
        <div class="login-box" style="width: 420px;">
        <div class="login-logo">
            <img src="@/assets/logoArendal.png" alt="Arendal" />
        </div>
        <!-- /.login-logo -->
        <div class="card">
            <div class="card-body login-card-body">
            <p class="login-box-msg">{{LangSelected.Externo.Login.TituloLogin}}</p>

            <form action="#" @submit.prevent="logear">
                <div class="input-group mb-3">
                <input type="email" class="form-control" :disabled=disabledwait v-model="correo" :placeholder="LangSelected.Externo.Login.CorreoHint">
                <div class="input-group-append">
                    <div class="input-group-text">
                    <span class="fas fa-envelope"></span>
                    </div>
                </div>
                </div>
                <div class="input-group mb-3">
                <input type="password" class="form-control" :disabled=disabledwait v-model="pass" :placeholder="LangSelected.Externo.Login.ContrasenaHint">
                <div class="input-group-append">
                    <div class="input-group-text">
                    <span class="fas fa-lock"></span>
                    </div>
                </div>
                </div>
                <div class="row">
                <div class="col-8">
                    <div class="icheck-primary">
                    <input type="checkbox" id="remember">
                    <label for="remember">
                        {{LangSelected.Externo.Login.RecordarContrasena}}
                    </label>
                    <router-link style="display: block;padding-left: 30px;" to="/recuperar">{{LangSelected.Externo.Login.OlvideContrasena}}</router-link>
                    </div>
                </div>
                
                <!-- /.col -->
               
                <div class="col-4"> 
                    <button class="btn btn-primary btn-block" :disabled=disabledwait>{{LangSelected.Externo.Login.BtnLogin}}</button>
                    <!-- <router-link class="btn btn-primary btn-block" to="/home">Entrar</router-link> -->
                </div>
                <!-- /.col -->
                </div>
            </form>
            
            <!-- <p class="mb-1">
                <a href="forgot-password.html">Olvidé mi contraseña</a>                
            </p> -->
             <br/>            
             <!--<div class="">                    
                    <router-link class="btn btn-block bg-gradient-success" to="/registro">{{LangSelected.Externo.Login.BtnRegistro}}</router-link>
                </div>-->
            </div>
           
        </div>
        </div>
       
            </div>
    </div>
</template>

<script>


export const RUTA_SERVIDOR = process.env.VUE_APP_RUTA_API;

import notify from 'devextreme/ui/notify';
import md5 from 'js-md5';
import { DxLoadPanel } from 'devextreme-vue/load-panel';




export default {
    components: {
        DxLoadPanel
    },
    data() {
        return {
            LangSelected:JSON.parse(localStorage.getItem('languageInfo')),
            loadingVisible: false,//Configuracion de loader
            showIndicator: true,
            shading: true,
            showPane: true,
            closeOnOutsideClick: false,

            correo: '',
            pass: '',

            disabledwait:false,
            timeoutVar:null
        }
    },
    created() {
        var that = this;
        var now = new Date();//.toLocaleString('es-MX');
        console.log(now);
        console.log(that.$cookies.get("TiempoEspera"));
        var intentos = {};
        if(!that.$cookies.get("TiempoEspera")){
            intentos={try:0,expired:null}
            that.$cookies.set("TiempoEspera",intentos); 
            console.log(that.$cookies.get("TiempoEspera"));
        }else{
            if(that.$cookies.get("TiempoEspera").try==5){
                that.disabledwait=true;

                const date1 = new Date(that.$cookies.get("TiempoEspera").expired);
                const date2 = new Date(now);
                console.log({dato:'actual',date2})
                console.log({dato:'expiro',date1})

                const diffTime = Math.abs(date1 - date2);
                //const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); 
                if(diffTime>=60000){
                    intentos={try:0,expired:null}
                    that.$cookies.set("TiempoEspera",intentos); 
                    that.disabledwait = false;
                }else if(diffTime<=60000){
                    setTimeout(function(){ 
                        
                    notify(that.LangSelected.Externo.Login.Notify.IntentosExcedidos, 'warning', 60000-diffTime);
                    }, 20);
                    that.timeoutVar = setTimeout(function(){ 
                        if(that.$cookies.get("TiempoEspera").try>=5){
                            notify(that.LangSelected.Externo.Login.Notify.TerminoTiempoEspera, 'success');
                        }
                        that.$cookies.set("TiempoEspera",{try:0,expired:null});
                        console.log(that.$cookies.get("TiempoEspera"));
                        that.disabledwait=false;
                    }, 60000-diffTime);
                }else{
                    intentos={try:0,expired:null}
                    that.$cookies.set("TiempoEspera",intentos); 
                    that.disabledwait = false;
                }



                console.log(diffTime + " milliseconds");
                //console.log(diffDays + " days");

            }
        }
    },
    name: 'Login',
    methods: {
        logear() {
            var that = this;
            if (!that.correo || !that.pass) {
                notify('Es necesario ingresar correo y contraseña', 'error')
                return;
            }
            that.loadingVisible = true;
            let email = that.correo
            let password = md5(that.pass)
            that.$store.dispatch('login', {
                email,
                password
            })
            .then((response) => {
                const loginData = Array.isArray(response.data) ? response.data[0] : response.data;
                if (loginData.Estatus == 'OK') {
                    that.$router.push('/OCDocPendiente')
                    that.$cookies.remove("TiempoEspera");
                } else {
                    var intentos={};
                    if(!that.$cookies.get("TiempoEspera")){
                        intentos={try:0,expired:null}
                        that.$cookies.set("TiempoEspera",intentos);
                    }

                    var now = new Date();
                    if(that.timeoutVar){
                        clearTimeout(that.timeoutVar);
                    }

                    intentos={try:that.$cookies.get("TiempoEspera").try+1,expired:now}
                    that.$cookies.set("TiempoEspera",intentos);
                    if(that.$cookies.get("TiempoEspera").try==5){
                        that.disabledwait=true;
                        notify(that.LangSelected.Externo.Login.Notify.IntentosExcedidos, 'warning', 60000);
                    }else{
                        notify(loginData.Mensaje, 'error');
                    }
                    that.timeoutVar = setTimeout(function(){
                        if(that.$cookies.get("TiempoEspera").try>=5){
                            notify(that.LangSelected.Externo.Login.Notify.TerminoTiempoEspera, 'success');
                        }
                        that.$cookies.set("TiempoEspera",{try:0,expired:null});
                        that.disabledwait=false;
                    }, 60000);
                }
                that.loadingVisible = false;
            })
            .catch(err => {
                console.log(err)
                const msg = err.response?.data?.message || that.LangSelected.Externo.Login.Notify.ErrorInesperado || 'Error al iniciar sesión'
                notify(msg, 'error', 10000)
                that.loadingVisible = false;
            })
        },
        onShown() {
            console.log('Mostrando loader...');
        },
        onHidden() {
            console.log('Cerrando loader...');
        },
        
        enabledAll:function(){
            console.log('reestableciendo');
            this.disabledwait=false;
        }
    },
    watch: {
        timeoutVar(val){
            console.log(val);
        }
    }
}
</script>